import App from './App.svelte';
import AccountDashboard from './pages/account/dashboard.svelte';
import AccountOverview from './pages/account/overview.svelte';
import ChargeupIndex from './pages/chargeup/index.svelte';
import ChargeupSuccess from './pages/chargeup/success.svelte';
import ComponentsIndex from './pages/builder/index.svelte';
import EntryPage from './pages/entry/index.svelte';
import EntryLinkPage from './pages/entry/link.svelte';
import EntryWaitingPage from './pages/entry/waiting.svelte';
import EntryWelcomePage from './pages/entry/welcome.svelte';
import EntryVerifyPage from './pages/entry/verify.svelte';
import Error404 from './pages/errors/404.svelte';
import FormsAdd from './pages/forms/add.svelte';
import FormsDelete from './pages/forms/delete.svelte';
import FormOverview from './pages/forms/overview.svelte';
import FormsEdit from './pages/forms/edit.svelte';
import LogoutPage from './pages/auth/logout.svelte';
import SitesDelete from './pages/sites/delete.svelte';
import SitesAdd from './pages/sites/add.svelte';
import SitesAddFirst from './pages/sites/first.svelte';
import SitesEdit from './pages/sites/edit.svelte';
import SiteOverview from './pages/sites/overview.svelte';

window.AccountIndex = AccountOverview;
window.AccountList = AccountDashboard;
window.AccountDashboard = AccountDashboard;
window.AccountOverview = AccountOverview;
window.ChargeupIndex = ChargeupIndex;
window.ChargeupSuccess = ChargeupSuccess;
window.ComponentsIndex = ComponentsIndex;
window.EntryLinkPage = EntryLinkPage;
window.EntryPage = EntryPage;
window.EntryWaitingPage = EntryWaitingPage;
window.EntryWelcomePage = EntryWelcomePage;
window.EntryVerifyPage = EntryVerifyPage;
window.Error404 = Error404;
window.FormOverview = FormOverview;
window.FormsAdd = FormsAdd;
window.FormsEdit = FormsEdit;
window.FormsDelete = FormsDelete;
window.LogoutPage = LogoutPage;
window.SitesDelete = SitesDelete;
window.SitesAdd = SitesAdd;
window.SitesAddFirst = SitesAddFirst;
window.SitesEdit = SitesEdit;
window.SiteOverview = SiteOverview;

const app = new App({
  target: document.body,
  props: {
    params: null
  },
});

export default app;
